import React from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from '@emotion/styled';
import RoundButton from '../../../components/RoundButton';
import CommonSection from '../../../components/CommonSection';
import AnimatedSection from '../../../components/AnimatedSection';

import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Autoplay, Lazy } from 'swiper';

import 'swiper/swiper.scss'

import { useLocalization } from "gatsby-theme-i18n";

import { useStaticQuery, graphql } from "gatsby"

import * as breakpoint from '../../../styles/breakpoints.module.scss';

import GoodsRotateBanner from './GoodsRotateBanner';

SwiperCore.use([Autoplay,Lazy]);

const CrosssiteSalesSection = () => {

  const data = useStaticQuery(graphql`
    query CrosssiteSalesSection {
      banner_goods : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/streaming/banner_goods.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      banner_ingame : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/streaming/banner_ingame.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      banner_expansion : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/streaming/banner_expansion.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      
    }
  `); 

  const params = {
    allowTouchMove:true,
    lazyload : {
      loadPrevNext:true
    },
    spaceBetween: 0,
    slidesPerView: 'auto'
  }
  const { t } = useLocalization();

  return (
  <AnimatedSection>
    <SectionWrapper>
      <Swiper {...params}>
        <SwiperSlide>
          <SlideContent>
            <ColumnHeadline>
              <span className="subtitle">{t('streaming.widget.goods.subtitle')}</span>
              <span className="title">{t('streaming.widget.goods.title')}</span>
            </ColumnHeadline>
            <ImageFrame>
              <GoodsRotateBanner />
            </ImageFrame>
            <Button color="#F50057" size={'large'} href={t('streaming.widget.goods.button.url')}>{t('streaming.widget.goods.button.label')}</Button>
          </SlideContent>
        </SwiperSlide>
        <SwiperSlide>
          <SlideContent>
            <ColumnHeadline>
              <span className="subtitle">{t('streaming.widget.ingame_item.subtitle')}</span>
              <span className="title">{t('streaming.widget.ingame_item.title')}</span>
            </ColumnHeadline>
            <ImageFrame>
              <GatsbyImage image={getImage(data.banner_ingame)} alt={t('streaming.widget.ingame_item.title')} />
            </ImageFrame>
            <Button color="#F50057" size={'large'} href={t('streaming.widget.ingame_item.button.url')}>{t('streaming.widget.ingame_item.button.label')}</Button>
          </SlideContent>
        </SwiperSlide>
        <SwiperSlide>
          <SlideContent>
            <ColumnHeadline>
              <span className="subtitle">{t('streaming.widget.expansion.subtitle')}</span>
              <span className="title">{t('streaming.widget.expansion.title')}</span>
            </ColumnHeadline>
            <ImageFrame>
              <GatsbyImage image={getImage(data.banner_expansion)} alt={t('streaming.widget.expansion.title')} />
            </ImageFrame>
            <Button color="#F50057" size={'large'} href={t('streaming.widget.expansion.button.url')}>{t('streaming.widget.expansion.button.label')}</Button>
          </SlideContent>
        </SwiperSlide>
      </Swiper>
    </SectionWrapper>
  </AnimatedSection>);
}
 
export default CrosssiteSalesSection;


const SectionWrapper = styled(CommonSection)`
  >div{
    max-width: calc(1344px + 96px);
    display: block;
  }

  .swiper-wrapper, .swiper-container{
    overflow:visible;
  }

  @media only screen and (min-width: ${breakpoint.mdMin}){
    .swiper-container{
      width:auto;
      margin:0 -24px;
      .swiper-wrapper{
        width:100%;
        transform:none !important;
      }
      .swiper-slide{
        width:33.3333%;
        padding:0 24px;
        box-sizing:border-box;
      }
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    .swiper-container{
      width:auto;
      margin:0 -16px;
      .swiper-slide{
        width:320px;
        padding:0 16px;
        box-sizing:border-box;
      }
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    .swiper-container{
      margin:0 -8px;
      .swiper-slide{
        width:256px;
        padding:0 8px;
      }
    }
  }

  
`

const SlideContent = styled.div`
  text-align:center;

  
`

const ColumnHeadline = styled.div`
  text-align:center;
  .subtitle{
    display:block;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.03em;
    font-weight: 900;
    margin-bottom:8px;
    color: #D00F31;
  }
  .title{
    display:block;
    letter-spacing: 0.03em;
    font-weight: 900;
    font-size: 36px;
    line-height: 48px;
    color: #2C2C2E;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    .subtitle{
      font-size: 12px;
      line-height: 16px;  
      margin-bottom:4px;
    }
    .title{
      font-size: 28px;
      line-height: 36px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    .subtitle{
      font-size: 10px;
      line-height: 14px;
      margin-bottom:0px;
    }
    .title{
      font-size: 20px;
      line-height: 28px;
    }
  }
`

const ImageFrame = styled.div`
  margin:48px 0;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  overflow:hidden;
  position:relative;
  z-index:1;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:32px 0;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:16px 0;
  }
`

const Button = styled(RoundButton)`
  font-size: 20px;
  line-height: 32px;
  height:auto;
  padding:16px 32px;
  min-width:288px;
  margin:0 auto;

  @media only screen and (max-width: ${breakpoint.smMax}){
    height:auto;
    font-size: 17px;
    line-height: 24px;
    padding:12px 24px;
    min-width:0;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    height:auto;
    font-size: 14px;
    line-height: 20px;
    padding:8px 16px;
    min-width:144px;
    width:auto;
  }
`
